import { FETCH_BANNER_ID } from "../actions/types";

export const idReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_BANNER_ID:
      return action.payload;
    default:
      return state;
  }
};
